import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RedirectService } from '@common/services/redirect/redirect.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-session-call-redirect',
  templateUrl: './session-call-redirect.component.html',
})
export class SessionCallRedirectComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  constructor(private activatedRoute: ActivatedRoute, private redirectService: RedirectService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.activatedRoute.paramMap.subscribe(async (params) => {
        const sessionId = params.get('sessionId');
        const redirectResponse = await this.redirectService.fetchCallBySessionDeeplink(sessionId);

        window.location.replace(redirectResponse.Deeplink);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
